import { useFlag } from '../../hooks/useFeatureFlags';

/**
 * PlanRequiredNotice (task 467) — the shared disabled-with-reason presentation
 * for AI entry points gated by `useRequiresPlan()`. Rendered next to (or
 * under) the disabled primary action so the reason and the remedy sit at the
 * point of intent. Copy matches the task-466 banner vocabulary so the no-plan
 * state reads as one system.
 *
 * Task 1018: this pre-flight notice is the FIFTH surface of
 * `innovate.fe.plan.no-plan-notices`, alongside the NoPlanBanner, the PlanBadge
 * "No plan" state, the dashboard onboarding "Choose your plan" step and its plan
 * callout. The flag only decides whether the reason line renders — every caller
 * keeps its own `requiresPlan` gate and its disabled action either way, and the
 * server-side refusals (the `402` `ChoosePlanPrompt`, the friendly
 * `no_active_plan` copy) are untouched.
 */
export default function PlanRequiredNotice({ className = '' }: { className?: string }) {
  const noticesEnabled = useFlag('innovate.fe.plan.no-plan-notices');

  // Reminders switched off (task 1018) — the action stays disabled, the
  // explanatory line does not render.
  if (!noticesEnabled) return null;

  return (
    <p
      data-testid="plan-required-notice"
      className={`text-xs text-amber-700 dark:text-amber-400 ${className}`.trim()}
    >
      Requires a plan —{' '}
      {/* Plain anchor (not router Link): renders inside varied surfaces and
          must stay free of router coupling (UpgradePrompt precedent). */}
      <a
        href="/settings/subscription"
        className="font-medium underline hover:text-amber-800 dark:hover:text-amber-300"
      >
        choose one to enable
      </a>
    </p>
  );
}
